// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"44":"ba1d11d7","68":"a78857f9"}[chunkId] + ".js";
};